import { render, staticRenderFns } from "./GoodsCapAdminView.vue?vue&type=template&id=62ceda05&"
import script from "./GoodsCapAdminView.vue?vue&type=script&lang=js&"
export * from "./GoodsCapAdminView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCapAdminView.vue?vue&type=style&index=0&id=62ceda05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports